module.exports = __webpack_public_path__ + "img/huangguan@3x.d818a222.png";